/**
 * Convert a <select> to a nice, non-native, accessible, pretty <ul> version
 *
 * Optional: add a data attribute to each <option> to force the <li> to contain an <a href="/link/here"> instead of <button>
 * e.g. <option value="1" data-link="/link/here">Option 1</option>
 *
 *  <div class="dropdown -is-select js-dropdown">
 *      <select class="dropdown__select js-dropdown-select">
 *          <option value="">Please select...</option>
 *          <option value="1">Option 1</option>
 *          <option value="2">Option 2</option>
 *          <option value="3">Option 3</option>
 *          ...
 *      </select>
 *  </div>
 */
let count = 0;

export function init(container, callback) {

    count++;

    // This is no longer a <select> so remove the <select>'s down arrow style
    container.classList.remove('-is-select');

    // Constants
    const parser = new DOMParser();
    const select = container.querySelector('.js-dropdown-select');
    const options = select.options;

    const generateXmlString = (parser, template, options, listId) => {

        let html; // Return string

        // Once the button is sorted, add it to the header
        let tmpHeader = parser.parseFromString(template.header, 'application/xhtml+xml');

        // Create better named variables for important elements
        let domNodes = tmpHeader.firstChild;
        let domList = domNodes.querySelector('.js-dropdown-list');

        // All <select> will have more than 1 item, and often the first item isn't a proper option (e.g. 'Please select...')
        // so we check the 2nd item.
        if (typeof options[1] !== 'undefined') {

            // Drop the default title (i.e. Please select...) into the <button>
            let tmpItem = parser.parseFromString(template.button, 'application/xhtml+xml');
            let tmpLabel = tmpItem.querySelector('.js-dropdown-label');

            // Drop the default title (i.e. Please select...) into the <a>
            tmpLabel.innerHTML = `<span>${options[0].text}</span>`;

            console.log(tmpItem.firstChild);

            console.log(domNodes.firstChild);

            // Add the <button> or <a> to the new bit of the DOM we're creating
            domNodes.insertBefore(tmpItem.firstChild, domNodes.firstChild);

            // Iterate over all the <option> tags
            for (let i = 0; i < options.length; i++) {

                let itemLi = parser.parseFromString(template.item, 'text/html').querySelector('li');    // Parse a templated <li> into a DOM node

                let itemNode, itemEl;

                // Check if <a> or <button> required inside each item
                if (options[i].hasAttribute('data-link')) {
                    itemNode = parser.parseFromString(template.item_link, 'application/xhtml+xml');
                    itemEl = itemNode.querySelector('a');
                    itemEl.setAttribute('href', options[i].getAttribute('data-link')); // Set the href from the data-link provided
                    itemEl.classList.add('js-no-hijack');
                } else {
                    itemNode = parser.parseFromString(template.item_button, 'application/xhtml+xml');
                    itemEl = itemNode.querySelector('button');
                }

                itemEl.setAttribute('id', `dropdown-${listId}-${i + 1}`);
                itemEl.setAttribute('data-value', options[i].value);

                // Add the text inside the <a> or <button>'s tag
                itemEl.textContent = options[i].text;

                // Add a selected style to the option that was selected in the original <select>
                if (options[i].hasAttribute('selected')) {
                    itemEl.classList.add('-selected');
                } else {
                    itemEl.classList.remove('-selected');
                }

                itemLi.appendChild(itemEl);
                domList.appendChild(itemLi);
            }

            let ghostDiv = document.createElement('div');
            ghostDiv.appendChild(domNodes);

            html = ghostDiv.innerHTML;
        }

        return html;
    };

    // Variables
    let template = {
        header: `
            <div class="dropdown__container js-dropdown-container">
                <ul class="dropdown__list js-dropdown-list js-category-filter" role="listbox" tabindex="0" aria-activedescendant="dropdown-${count}-1">
                </ul>
            </div>`,

        button: `
            <button type="button" class="dropdown__label js-dropdown-label"></button>`,

        item: `
            <li></li>`,

        item_link: `
            <a href="javascript:;" class="dropdown__link js-dropdown-item" role="option"></a>`,

        item_button: `
            <button class="dropdown__link js-dropdown-item" data-value="" role="option"></button>`,

        item_empty: '' +
            'Please select...',
    };
    let xmlString = generateXmlString(parser, template, options, count);

    // Parse new non-native <ul><li> version of <select><option>
    const doc = parser.parseFromString(xmlString, 'application/xhtml+xml');

    // Replace
    let ghostDiv = document.createElement('div');
    ghostDiv.appendChild(doc.firstChild);
    container.innerHTML = ghostDiv.innerHTML;

    requestAnimationFrame(() => {
        const label = document.querySelector('.js-dropdown-label');
        const list = document.querySelector('.js-dropdown-list');
        // Now we have the dropdown labels, add event listeners
        if (typeof callback !== 'undefined') {
            // callback for item clicks
            container.addEventListener('click', e => {
                if (parallax.isAdmin) return;

                const item = e.target.closest('.js-dropdown-item');
                if (item) {
                    container.classList.remove('-active');
                    e.preventDefault();
                    callback(item);

                    // update label
                    label.innerHTML = `<span>${item.textContent}</span>`;

                    // update aria-activedescendant
                    list.setAttribute('aria-activedescendant', item.id);
                }
            });
        }
        label.addEventListener('click', e => {
            container.classList.add('-active');
        });
        var handleDropdownEvent = e => {

            if (! e.target.closest('.js-dropdown')) {
                container.classList.remove('-active');
            }
        };
        window.addEventListener('click', handleDropdownEvent);
        window.addEventListener('touchstart', handleDropdownEvent);
    });
}



// WEBPACK FOOTER //
// ./assets/js/components/_dropdown.js